"use client";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { Collapsible } from '@/components/ui/collapsible';
import { cn } from '@/lib/utils';
import Link from 'next/link';
import React, { useState } from 'react'

const EasyTransferToUk = () => {
    const [expanded, setExpanded] = useState<boolean>(false)
    return (
        <>

            <section
                id="uk"
                className={cn(
                    `p-0`,
                    `2xl:mb-[4.3125rem] xl:mb-[4.3125rem]`,
                    `md:mb-[3.75rem] md:scroll-mt-40`,
                    `w-full max-w-[90rem] m-[0_auto] clear-both mb-8 block scroll-mt-20`
                )}>
                <h6 className={cn(
                    `xl:box-content md:px-[3.625rem] md:max-w-[43.125rem] 
                       md:mx-auto md:w-full [word-wrap:break-word] xl:text-[1.75rem] 
                       xl:leading-[2.5rem] md:text-[1.25rem] md:leading-[2.1875rem]
                        md:mb-4 
                       md:clear-none 
                       mt-0 mb-[0.375rem] text-[1.15rem] leading-[1.6875rem] clear-both font-bold`
                )}>
                    Easy Transfer To Uk

                </h6>

                <p className={`xl:box-content md:px-[3.625rem] md:max-w-[43.125rem] md:mx-auto md:w-full
                  [word-wrap:break-word;] xl:mb-[1.5rem] md:mb-[1.9375rem] md:text-base md:leading-8 adelle mt-0`}>
                    PCPS College offers internationally recognised study pathways through its academic partnership with the
                    <strong> University of Bedfordshire (UK)</strong>,
                    giving students access to globally valued qualifications and flexible progression opportunities.
                </p>

                <p className={`xl:box-content md:px-[3.625rem] md:max-w-[43.125rem] md:mx-auto md:w-full
                  [word-wrap:break-word;] xl:mb-[1.5rem] md:mb-[1.9375rem] md:text-base md:leading-8 adelle mt-0`}>
                    All programmes at PCPS follow the <strong>academic framework, assessment standards, and quality assurance processes of the University of Bedfordshire</strong>, ensuring education that meets UK higher education standards.
                </p>

                {/*  <div
                    className={`xl:box-content md:px-[3.625rem] md:max-w-[43.125rem] md:mx-auto md:w-full
              [word-wrap:break-word;] xl:mb-[1.5rem] md:mb-[1.9375rem] md:text-base md:leading-8 adelle mt-0`}
                >
                    <div className="flex justify-start gap-6 md:gap-12 w-full my-4">
                        <button
                            // href={"https://www.beds.ac.uk/"}
                            // target="_blank"
                            className={`futura-medium cursor-pointer text-[0.6875rem] leading-[1.125rem] tracking-[0.0625rem] text-black [text-decoration:none] uppercase
                    border border-black p-[0.875rem_1.25rem] inline-block bg-white relative overflow-visible transition-[all_0.35s_ease-out]
                    after:content-[url(/svgs/longarrowright-red.svg)] after:text-[1.0625rem] after:pl-[0.3125rem] after:block after:float-right 
                    after:transition-[all_0.35s_ease-out] after:translate-y-[-0.125rem] hover:text-[#A31F34] hover:border-[#A31F34] hover:transition-[all_0.15s_ease]
                    after:hover:text-[#A31F34] after:hover:translate-x-[0.625rem] after:hover:transition-[all_0.15s_ease]
                      hover:after:text-[#A31F34] hover:after:transition-[all_0.15s_ease]
                            hover:after:transform hover:after:translate-x-[0.625rem]
                            
                  `}
                            onClick={() => {
                                setExpanded(pre => !pre)
                            }}
                        >
                            Explore more
                        </button>
                    </div>
                </div> */}

            </section>

            {/*   {expanded && <>
                <div
                    className={cn(
                        `p-0`,
                        `2xl:mb-[4.3125rem] xl:mb-[4.3125rem]`,
                        `md:mb-[3.75rem] `,
                        `w-full max-w-[90rem] m-[0_auto] clear-both mb-8 block`,
                        `transition-all duration-300 ease-in-out`
                    )}
                >
                    <h5 className={cn(
                        `xl:box-content md:px-[3.625rem] md:max-w-[43.125rem] 
                            md:mx-auto md:w-full [word-wrap:break-word] xl:text-[1.875rem] 
                            xl:leading-[2.5rem] md:text-[1.625rem] md:leading-[2.1875rem]
                             md:mb-4 
                            md:clear-none 
                            mt-0 mb-[0.375rem] text-[1.25rem] leading-[1.6875rem] clear-both font-bold`
                    )}
                    >Progression to the University of Bedfordshire</h5>
                    <p className={`xl:box-content md:px-[3.625rem] md:max-w-[43.125rem] md:mx-auto md:w-full
                  [word-wrap:break-word;] xl:mb-[1.5rem] md:mb-[1.9375rem] md:text-base md:leading-8 adelle mt-0`}>
                        Students at PCPS can:
                    </p>
                    <ul
                        className={cn(
                            // xl (≥1210px): block, custom margin/padding, auto width, no left padding
                            "xl:block xl:m-[1rem_auto_2.1875rem] xl:p-[0_3.625rem] xl:w-auto",
                            `xl:box-content md:px-[3.625rem] md:max-w-[43.125rem]`,
                            // md (≥768px): block, center horizontally, 0 horizontal padding, auto width, no left padding
                            "md:block md:mx-auto md:w-auto md:px-0 md:pl-0",
                            // base: inline-block, clear-both, no bullets, bottom margin, no left padding, full width, break words
                            "inline-block w-full clear-both [list-style:none] mb-[2.4375rem] pl-0 [overflow-wrap:break-word] [word-wrap:break-word]"
                        )}
                    >
                        {
                            [
                                "Progress to the University of Bedfordshire in the UK, based on academic performance and regulatory requirements.",
                                "Transfer credits under approved academic arrangements.",
                                "Continue their studies within the same degree structure without loss of academic recognition."
                            ].map(item => {
                                return <li
                                    key={item.toLowerCase()}
                                    className={cn(
                                        // Insert list-bullet utility styles to simulate ::before
                                        `before:content-[''] before:absolute before:left-0 
                                            before:top-[0.3125rem] before:w-[0.75rem] before:h-[0.75rem] 
                                            before:bg-[url(/svgs/list--bullet.svg)] 
                                            before:bg-no-repeat`,

                                        // Base styles
                                        ` font-normal text-[#272727] text-[0.875rem] leading-[1.3125rem] pl-6 mb-[1.6875rem] list-inside relative`,

                                        // md (≥768px) adjustments
                                        `md:text-[1rem] md:leading-6 md:pl-[3.75rem] md:mb-2.5 md:before:left-[0.875rem] md:before:top-[0.375rem]`,

                                        // xl (≥1210px)
                                        `xl:mb-5 xl:max-w-[88%] xl:before:top-[0.3125rem] xl:before:left-0`
                                    )}
                                >
                                    {item}
                                </li>
                            })
                        }
                    </ul>

                    <p className={`xl:box-content md:px-[3.625rem] md:max-w-[43.125rem] md:mx-auto md:w-full
                  [word-wrap:break-word;] xl:mb-[1.5rem] md:mb-[1.9375rem] md:text-base md:leading-8 adelle mt-0`}>
                        This ensures seamless academic mobility while maintaining continuity in learning outcomes and degree integrity.
                    </p>
                </div>



                <div
                    className={cn(
                        `p-0`,
                        `2xl:mb-[4.3125rem] xl:mb-[4.3125rem]`,
                        `md:mb-[3.75rem] `,
                        `w-full max-w-[90rem] m-[0_auto] clear-both mb-8 block`,
                        `transition-all duration-300 ease-in-out`
                    )}
                >
                    <h5 className={cn(
                        `xl:box-content md:px-[3.625rem] md:max-w-[43.125rem] 
                            md:mx-auto md:w-full [word-wrap:break-word] xl:text-[1.875rem] 
                            xl:leading-[2.5rem] md:text-[1.625rem] md:leading-[2.1875rem]
                             md:mb-4 
                            md:clear-none 
                            mt-0 mb-[0.375rem] text-[1.25rem] leading-[1.6875rem] clear-both font-bold`
                    )}
                    >Progression to Other Universities and Colleges</h5>
                    <p className={`xl:box-content md:px-[3.625rem] md:max-w-[43.125rem] md:mx-auto md:w-full
                  [word-wrap:break-word;] xl:mb-[1.5rem] md:mb-[1.9375rem] md:text-base md:leading-8 adelle mt-0`}>
                        The UK-accredited academic structure at PCPS also supports progression to other recognised universities and higher education institutions worldwide, subject to institutional policies. Benefits include:
                    </p>
                    <ul
                        className={cn(
                            // xl (≥1210px): block, custom margin/padding, auto width, no left padding
                            "xl:block xl:m-[1rem_auto_2.1875rem] xl:p-[0_3.625rem] xl:w-auto",
                            `xl:box-content md:px-[3.625rem] md:max-w-[43.125rem]`,
                            // md (≥768px): block, center horizontally, 0 horizontal padding, auto width, no left padding
                            "md:block md:mx-auto md:w-auto md:px-0 md:pl-0",
                            // base: inline-block, clear-both, no bullets, bottom margin, no left padding, full width, break words
                            "inline-block w-full clear-both [list-style:none] mb-[2.4375rem] pl-0 [overflow-wrap:break-word] [word-wrap:break-word]"
                        )}
                    >
                        {
                            [
                                "Internationally recognised credits aligned with UK frameworks",
                                "Compatibility with global qualification systems",
                                "Strong academic transcripts to support further study applications"
                            ].map(item => {
                                return <li
                                    key={item.toLowerCase()}
                                    className={cn(
                                        // Insert list-bullet utility styles to simulate ::before
                                        `before:content-[''] before:absolute before:left-0 
                                            before:top-[0.3125rem] before:w-[0.75rem] before:h-[0.75rem] 
                                            before:bg-[url(/svgs/list--bullet.svg)] 
                                            before:bg-no-repeat`,

                                        // Base styles
                                        ` font-normal text-[#272727] text-[0.875rem] leading-[1.3125rem] pl-6 mb-[1.6875rem] list-inside relative`,

                                        // md (≥768px) adjustments
                                        `md:text-[1rem] md:leading-6 md:pl-[3.75rem] md:mb-2.5 md:before:left-[0.875rem] md:before:top-[0.375rem]`,

                                        // xl (≥1210px)
                                        `xl:mb-5 xl:max-w-[88%] xl:before:top-[0.3125rem] xl:before:left-0`
                                    )}
                                >
                                    {item}
                                </li>
                            })
                        }
                    </ul>

                    <p className={`xl:box-content md:px-[3.625rem] md:max-w-[43.125rem] md:mx-auto md:w-full
                  [word-wrap:break-word;] xl:mb-[1.5rem] md:mb-[1.9375rem] md:text-base md:leading-8 adelle mt-0 italic`}>
                        Final progression decisions are made by the receiving institution.
                    </p>
                </div>
            </>} */}
            {/*  <Collapsible>
            
            </Collapsible> */}
            <Accordion
                type="single"
                collapsible
                className="w-full"
            // defaultValue="pthuob"
            >
                <AccordionItem value="pthuob" className=''

                >
                    <AccordionTrigger className='w-full cursor-pointer'>
                        <h5 className={cn(
                            `xl:box-content md:px-[3.625rem] md:max-w-[43.125rem] 
                            md:mx-auto md:w-full [word-wrap:break-word] xl:text-[1.875rem] 
                            xl:leading-[2.5rem] md:text-[1.625rem] md:leading-[2.1875rem]
                             md:mb-4 
                            md:clear-none 
                            mt-0 mb-[0.375rem] text-[1.25rem] leading-[1.6875rem] clear-both font-bold`
                        )}
                        >Progression to the University of Bedfordshire</h5>
                    </AccordionTrigger>

                    <AccordionContent>
                        <p className={`xl:box-content md:px-[3.625rem] md:max-w-[43.125rem] md:mx-auto md:w-full
                  [word-wrap:break-word;] xl:mb-[1.5rem] md:mb-[1.9375rem] md:text-base md:leading-8 adelle mt-0`}>
                            Students at PCPS can:
                        </p>
                        <ul
                            className={cn(
                                // xl (≥1210px): block, custom margin/padding, auto width, no left padding
                                "xl:block xl:m-[1rem_auto_2.1875rem] xl:p-[0_3.625rem] xl:w-auto",
                                `xl:box-content md:px-[3.625rem] md:max-w-[43.125rem]`,
                                // md (≥768px): block, center horizontally, 0 horizontal padding, auto width, no left padding
                                "md:block md:mx-auto md:w-auto md:px-0 md:pl-0",
                                // base: inline-block, clear-both, no bullets, bottom margin, no left padding, full width, break words
                                "inline-block w-full clear-both [list-style:none] mb-[2.4375rem] pl-0 [overflow-wrap:break-word] [word-wrap:break-word]"
                            )}
                        >
                            {
                                [
                                    "Progress to the University of Bedfordshire in the UK, based on academic performance and regulatory requirements.",
                                    "Transfer credits under approved academic arrangements.",
                                    "Continue their studies within the same degree structure without loss of academic recognition."
                                ].map(item => {
                                    return <li
                                        key={item.toLowerCase()}
                                        className={cn(
                                            // Insert list-bullet utility styles to simulate ::before
                                            `before:content-[''] before:absolute before:left-0 
                                            before:top-[0.3125rem] before:w-[0.75rem] before:h-[0.75rem] 
                                            before:bg-[url(/svgs/list--bullet.svg)] 
                                            before:bg-no-repeat`,

                                            // Base styles
                                            ` font-normal text-[#272727] text-[0.875rem] leading-[1.3125rem] pl-6 mb-[1.6875rem] list-inside relative`,

                                            // md (≥768px) adjustments
                                            `md:text-[1rem] md:leading-6 md:pl-[3.75rem] md:mb-2.5 md:before:left-[0.875rem] md:before:top-[0.375rem]`,

                                            // xl (≥1210px)
                                            `xl:mb-5 xl:max-w-[88%] xl:before:top-[0.3125rem] xl:before:left-0`
                                        )}
                                    >
                                        {item}
                                    </li>
                                })
                            }
                        </ul>

                        <p className={`xl:box-content md:px-[3.625rem] md:max-w-[43.125rem] md:mx-auto md:w-full
                  [word-wrap:break-word;] xl:mb-[1.5rem] md:mb-[1.9375rem] md:text-base md:leading-8 adelle mt-0`}>
                            This ensures seamless academic mobility while maintaining continuity in learning outcomes and degree integrity.
                        </p>

                    </AccordionContent>
                </AccordionItem>

                <AccordionItem value='ptouac'>
                    <AccordionTrigger>
                        <h5 className={cn(
                            `xl:box-content md:px-[3.625rem] md:max-w-[43.125rem] 
                            md:mx-auto md:w-full [word-wrap:break-word] xl:text-[1.875rem] 
                            xl:leading-[2.5rem] md:text-[1.625rem] md:leading-[2.1875rem]
                             md:mb-4 
                            md:clear-none 
                            mt-0 mb-[0.375rem] text-[1.25rem] leading-[1.6875rem] clear-both font-bold`
                        )}
                        >Progression to Other Universities and Colleges</h5>
                    </AccordionTrigger>
                    <AccordionContent>
                        <p className={`xl:box-content md:px-[3.625rem] md:max-w-[43.125rem] md:mx-auto md:w-full
                  [word-wrap:break-word;] xl:mb-[1.5rem] md:mb-[1.9375rem] md:text-base md:leading-8 adelle mt-0`}>
                            The UK-accredited academic structure at PCPS also supports progression to other recognised universities and higher education institutions worldwide, subject to institutional policies. Benefits include:
                        </p>
                        <ul
                            className={cn(
                                // xl (≥1210px): block, custom margin/padding, auto width, no left padding
                                "xl:block xl:m-[1rem_auto_2.1875rem] xl:p-[0_3.625rem] xl:w-auto",
                                `xl:box-content md:px-[3.625rem] md:max-w-[43.125rem]`,
                                // md (≥768px): block, center horizontally, 0 horizontal padding, auto width, no left padding
                                "md:block md:mx-auto md:w-auto md:px-0 md:pl-0",
                                // base: inline-block, clear-both, no bullets, bottom margin, no left padding, full width, break words
                                "inline-block w-full clear-both [list-style:none] mb-[2.4375rem] pl-0 [overflow-wrap:break-word] [word-wrap:break-word]"
                            )}
                        >
                            {
                                [
                                    "Internationally recognised credits aligned with UK frameworks",
                                    "Compatibility with global qualification systems",
                                    "Strong academic transcripts to support further study applications"
                                ].map(item => {
                                    return <li
                                        key={item.toLowerCase()}
                                        className={cn(
                                            // Insert list-bullet utility styles to simulate ::before
                                            `before:content-[''] before:absolute before:left-0 
                                            before:top-[0.3125rem] before:w-[0.75rem] before:h-[0.75rem] 
                                            before:bg-[url(/svgs/list--bullet.svg)] 
                                            before:bg-no-repeat`,

                                            // Base styles
                                            ` font-normal text-[#272727] text-[0.875rem] leading-[1.3125rem] pl-6 mb-[1.6875rem] list-inside relative`,

                                            // md (≥768px) adjustments
                                            `md:text-[1rem] md:leading-6 md:pl-[3.75rem] md:mb-2.5 md:before:left-[0.875rem] md:before:top-[0.375rem]`,

                                            // xl (≥1210px)
                                            `xl:mb-5 xl:max-w-[88%] xl:before:top-[0.3125rem] xl:before:left-0`
                                        )}
                                    >
                                        {item}
                                    </li>
                                })
                            }
                        </ul>

                        <p className={`xl:box-content md:px-[3.625rem] md:max-w-[43.125rem] md:mx-auto md:w-full
                  [word-wrap:break-word;] xl:mb-[1.5rem] md:mb-[1.9375rem] md:text-base md:leading-8 adelle mt-0 italic`}>
                            Final progression decisions are made by the receiving institution.
                        </p>
                    </AccordionContent>
                </AccordionItem>
            </Accordion>
        </>
    )
}

export default EasyTransferToUk